import { createSelector } from '@reduxjs/toolkit';

export const selectLoginLoading = state => state.auth?.loading;
export const selectAuth = createSelector(
  state => state.auth,
  auth => auth
);

export const selectAccountsDataOptions = createSelector(
  state => state.masters.accountsData || [],
  options => options
);
export const selectAccountsOptions = createSelector(
  state => state.masters.accounts || {},
  options => options
);
export const selectMasterOptionsLoading = state => state.masters.loading;
export const selectMasterOptions = createSelector(
  state => state.masters.options,
  options => options
);
export const selectAllMasterOptions = createSelector(
  state => state.masters.allOptions,
  options => options
);
export const selectAccountOptions = createSelector(
  state => state.masters.options?.accounts || [],
  options => options
);
export const selectBookOptions = createSelector(
  state => state.masters.options?.books || [],
  options => options
);
export const selectBrokerOptions = createSelector(
  state => state.masters.options?.brokers || [],
  options => options
);
export const selectAreaOptions = createSelector(
  state => state.masters.options?.areas || [],
  options => options
);
export const selectBanksOptions = createSelector(
  state => state.masters.options?.banks || [],
  options => options
);
export const selectSalesPersonsOptions = createSelector(
  state => state.masters.options?.salesPersons || [],
  options => options
);
export const selectPipeTypesOptions = createSelector(
  state => state.masters.options?.pipeTypes || [],
  options => options
);
export const selectLotOptions = createSelector(
  state => state.masters.options?.lots || [],
  options => options
);
export const selectItemOptions = createSelector(
  state => state.masters.options?.items || [],
  options => options
);
export const selectGradeOptions = createSelector(
  state => state.masters.options?.grades || [],
  options => options
);
export const selectTransporterOptions = createSelector(
  state => state.masters.options?.transporters || [],
  options => options
);
export const selectDesignOptions = createSelector(
  state => state.masters.options?.designs || [],
  options => options
);
export const selectVehicleOptions = createSelector(
  state => state.masters.options?.vehicles || [],
  options => options
);
export const selectStateOptions = createSelector(
  state => state.masters.options?.states || [],
  options => options
);
export const selectTdsSectionOptions = createSelector(
  state => state.masters.options?.tdsSections || [],
  options => options
);
export const selectScheduleOptions = createSelector(
  state => state.masters.options?.schedules || [],
  options => options
);

export const selectBobinTypeOptions = createSelector(
  state => state.masters.options?.bobinType || [],
  options => options
);

export const selectBranchesOptions = createSelector(
  state => state.masters.options?.branches || [],
  options => options
);

export const selectMachinesOptions = createSelector(
  state => state.masters.options?.machines || [],
  options => options
);

export const selectJobsOptions = createSelector(
  state => state.masters.options?.jobs || [],
  options => options
);

export const selectAccountLoading = state => state.account.loading;
export const selectAccounts = createSelector(
  state => state.account.accounts,
  accounts => accounts
);
export const selectAccountTotal = state => state.account.total;
export const selectAccountsWithPage = createSelector(
  state => state.account.accountsPage,
  accounts => accounts
);

export const selectItemLoading = state => state.item.loading;
export const selectItems = createSelector(
  state => state.item.items,
  items => items
);

export const selectItemsWithPage = createSelector(
  state => state.item.itemsPage,
  items => items
);

export const selectBrokerLoading = state => state.broker.loading;
export const selectBrokers = createSelector(
  state => state.broker.brokers,
  brokers => brokers
);

export const selectBrokersWithPage = createSelector(
  state => state.broker.brokersPage,
  brokers => brokers
);

export const selectAreaLoading = state => state.area.loading;
export const selectAreas = createSelector(
  state => state.area.areas,
  areas => areas
);

export const selectAreasWithPage = createSelector(
  state => state.area.areasPage,
  areas => areas
);

export const selectBanksLoading = state => state.banks.loading;
export const selectBanks = createSelector(
  state => state.banks.banks,
  banks => banks
);

export const selectBanksWithPage = createSelector(
  state => state.banks.banksPage,
  banks => banks
);


export const selectSalesPersonsLoading = state => state.salesPersons.loading;
export const selectSalesPersons = createSelector(
  state => state.salesPersons.salesPersons,
  salesPersons => salesPersons
);

export const selectSalesPersonsWithPage = createSelector(
  state => state.salesPersons.salesPersonsPage,
  salesPersons => salesPersons
);

export const selectPipeTypesLoading = state => state.pipeTypes.loading;
export const selectPipeTypes = createSelector(
  state => state.pipeTypes.pipeTypes,
  pipeTypes => pipeTypes
);

export const selectPipeTypesWithPage = createSelector(
  state => state.pipeTypes.pipeTypePage,
  pipeTypes => pipeTypes
);


export const selectBookLoading = state => state.book.loading;
export const selectBooks = createSelector(
  state => state.book.books,
  books => books
);

export const selectTransporterLoading = state => state.transporter.loading;
export const selectTransporters = createSelector(
  state => state.transporter.transporters,
  transporters => transporters
);

export const selectGradeLoading = state => state.grade.loading;
export const selectGrades = createSelector(
  state => state.grade.grades,
  grades => grades
);

export const selectLotLoading = state => state.lot.loading;
export const selectLots = createSelector(
  state => state.lot.lots,
  lots => lots
);

export const selectVehicleLoading = state => state.vehicle.loading;
export const selectVehicles = createSelector(
  state => state.vehicle.vehicles,
  vehicles => vehicles
);

export const selectReportMasterDetailLoading = state => state.reportMasterDetail.loading;
export const selectReportMasterDetail = createSelector(
  state => state.reportMasterDetail.reportMasterDetail,
  reportMasterDetail => reportMasterDetail
);
export const selectReportMasterWithDetail = createSelector(
  state => state.reportMasterDetail.reportMasterWithDetail || [],
  reportMasterWithDetail => reportMasterWithDetail
);
export const selectSalesBillLoading = state => state.inventory.salesBill.loading;
export const selectSalesBills = createSelector(
  state => state.inventory.salesBill.salesBills,
  bills => bills
);
export const selectSalesBillTotal = state => state.inventory.salesBill.total;
export const selectSalesBillsWithPage = createSelector(
  state => state.inventory.salesBill.salesBillsPage,
  bills => bills
);
export const selectAvailablePurchaseBillsForSalesBill = createSelector(
  state => state.inventory.salesBill.availablePurchaseBills,
  bills => bills
);

export const selectSalesOrderLoading = state => state.inventory.salesOrder.loading;
export const selectSalesOrders = createSelector(
  state => state.inventory.salesOrder.salesOrders,
  bills => bills
);
export const selectSalesOrderTotal = state => state.inventory.salesOrder.total;
export const selectSalesOrdersWithPage = createSelector(
  state => state.inventory.salesOrder.salesOrdersPage,
  bills => bills
);

export const selectProductionLoading = state => state.inventory.production.loading;
export const selectProductionError = state => state.inventory.production.error;
export const selectProductions = createSelector(
  state => state.inventory.production.productions,
  bills => bills
);

//  delivery Challan with page
export const selectProductionTotal = state => state.inventory.production.total;
export const selectProductionsWithPage = createSelector(
  state => state.inventory.production.productionsPage,
  bills => bills
);


export const selectProductionRePackingLoading = state => state.inventory.productionRepacking.loading;
export const selectProductionRePackingError = state => state.inventory.productionRepacking.error;
export const selectProductionRePackings = createSelector(
  state => state.inventory.productionRepacking.productions,
  bills => bills
);

//  repacking with page
export const selectProductionRePackingTotal = state => state.inventory.productionRepacking.total;
export const selectProductionRePackingsWithPage = createSelector(
  state => state.inventory.productionRepacking.productionsPage,
  bills => bills
);

export const selectDeliveryChallanLoading = state => state.inventory.deliveryChallan.loading;
export const selectDeliveryChallanError = state => state.inventory.deliveryChallan.error;
export const selectDeliveryChallans = createSelector(
  state => state.inventory.deliveryChallan.deliveryChallans,
  bills => bills
);

//  delivery Challan with page
export const selectDeliveryChallanTotal = state => state.inventory.deliveryChallan.total;
export const selectDeliveryChallansWithPage = createSelector(
  state => state.inventory.deliveryChallan.deliveryChallansPage,
  bills => bills
);

export const selectLastFiveDeliveryChallans = createSelector(
  state => state.inventory.deliveryChallan.lastFiveDeliveryChallans,
  bills => bills
);

// DCR Module
export const selectDeliveryChallanReturnLoading = state => state.inventory.deliveryChallanReturn.loading;
export const selectDeliveryChallanReturnError = state => state.inventory.deliveryChallanReturn.error;
export const selectDeliveryChallansReturns = createSelector(
  state => state.inventory.deliveryChallanReturn.deliveryChallanReturns,
  bills => bills
);


export const selectDeliveryChallanReturnTotal = state => state.inventory.deliveryChallanReturn.total;
export const selectDeliveryChallansReturnWithPage = createSelector(
  state => state.inventory.deliveryChallanReturn.deliveryChallanReturnsPage,
  bills => bills
);

export const selectGeneralSettingLoading = state => state.settings.loading;
export const selectGeneralSettings = createSelector(
  state => state.settings.generalSetting,
  settings => settings
);

export const selectPurchaseBillLoading = state => state.inventory.purchaseBill.loading;
export const selectPurchaseBills = createSelector(
  state => state.inventory.purchaseBill.purchaseBills,
  bills => bills
);
export const selectAvailableChallansForPurchaseBills = createSelector(
  state => state.inventory.purchaseBill.availableChallans,
  bills => bills
);
export const selectPurchaseBilltotal = state => state.inventory.purchaseBill.total;
export const selectPurchaseBillsWithPage = createSelector(
  state => state.inventory.purchaseBill.purchaseBillsPage,
  bills => bills
);

export const selectPurchaseOrderLoading = state => state.inventory.purchaseOrder.loading;
export const selectPurchaseOrders = createSelector(
  state => state.inventory.purchaseOrder.purchaseOrders,
  bills => bills
);

export const selectPurchaseChallanLoading = state => state.transaction.purchaseChallan.loading;
export const selectPurchaseChallans = createSelector(
  state => state.transaction.purchaseChallan.purchaseChallans,
  bills => bills
);
export const selectPurchaseChallanTotal = state => state.transaction.purchaseChallan.total;
export const selectPurchaseChallansWithPage = createSelector(
  state => state.transaction.purchaseChallan.purchaseChallansPage,
  bills => bills
);
export const selectPurchaseOrderTotal = state => state.inventory.purchaseOrder.total;
export const selectPurchaseOrdersWithPage = createSelector(
  state => state.inventory.purchaseOrder.purchaseOrdersPage,
  bills => bills
);

export const selectPurchaseBillReturnLoading = state => state.inventory.purchaseBillReturn.loading;
export const selectPurchaseBillReturns = createSelector(
  state => state.inventory.purchaseBillReturn.purchaseBillReturns,
  bills => bills
);
export const selectReturnOrdersForPurchaseBillReturns = createSelector(
  state => (state.inventory.purchaseBillReturn.returnOrders || []),
  bills => bills
);
export const selectPurchaseBillReturnTotal = state => state.inventory.purchaseBillReturn.total;
export const selectPurchaseBillReturnsWithPage = createSelector(
  state => state.inventory.purchaseBillReturn.purchaseBillReturnsPage,
  bills => bills
);

export const selectPurchaseChallanReturnLoading = state => state.transaction.purchaseChallanReturn.loading;
export const selectPurchaseChallanReturns = createSelector(
  state => state.transaction.purchaseChallanReturn.purchaseChallanReturns,
  bills => bills
);
export const selectReturnOrdersForPurchaseChallanReturns = createSelector(
  state => (state.transaction.purchaseChallanReturn.returnOrders || []),
  bills => bills
);
export const selectPurchaseChallanReturnTotal = state => state.transaction.purchaseChallanReturn.total;
export const selectPurchaseChallanReturnsWithPage = createSelector(
  state => state.transaction.purchaseChallanReturn.purchaseChallanReturnsPage,
  bills => bills
);

export const selectImportDataLoading = state => state.utility.importData.loading;

export const selectDebitNotesLoading = state => state.transaction.debitNote.loading;
export const selectDebitNotes = createSelector(
  state => state.transaction.debitNote.debitNotes,
  bills => bills
);

export const selectDebitNoteTotal = state => state.transaction.debitNote.total;
export const selectDebitNotesWithPage = createSelector(
  state => state.transaction.debitNote.debitNotesPage,
  bills => bills
);

export const selectCreditNotesLoading = state => state.transaction.creditNote.loading;
export const selectCreditNotes = createSelector(
  state => state.transaction.creditNote.creditNotes,
  bills => bills
);

export const selectCreditNoteTotal = state => state.transaction.creditNote.total;
export const selectCreditNotesWithPage = createSelector(
  state => state.transaction.creditNote.creditNotesPage,
  bills => bills
);

// Credit Note Bill Base
export const selectCreditNotesBillBaseLoading = state => state.transaction.creditNoteBillBase.loading;
export const selectCreditNotesBillBase = createSelector(
  state => state.transaction.creditNoteBillBase.creditNoteBillBases,
  bills => bills
);

export const selectCreditNoteBillBaseTotal = state => state.transaction.creditNoteBillBase.total;
export const selectCreditNotesBillBaseWithPage = createSelector(
  state => state.transaction.creditNoteBillBase.creditNoteBillBasesPage,
  bills => bills
);

export const selectBankReceiptsLoading = state => state.transaction.bankReceipt.loading;
export const selectBankReceipts = createSelector(
  state => state.transaction.bankReceipt.bankReceipts,
  bills => bills
);
export const selectBankReceiptTransactions = createSelector(
  state => state.transaction.bankReceiptTransaction.bankReceiptTransactions,
  bills => bills
);
export const selectAccountIdWiseConsigneeBankReceiptTransactions = createSelector(
  state => state.transaction.bankReceiptTransaction.accountIdWiseConsigneeBankReceiptTransactions,
  bills => bills
);
export const selectBankNameBankReceiptTransactions = createSelector(
  state => state.transaction.bankReceiptTransaction.bankNamesBankReceiptTransactions,
  bills => bills
);
export const selectBankReceiptsTotal = state => state.transaction.bankReceipt.total;
export const selectBankReceiptsWithPage = createSelector(
  state => state.transaction.bankReceipt.bankReceiptsPage,
  bills => bills
);

// Bank Receipt Returns
export const selectBankReceiptReturnsLoading = state => state.transaction.bankReceiptReturn.loading;
export const selectBankReceiptReturns = createSelector(
  state => state.transaction.bankReceiptReturn.bankReceiptReturns,
  bills => bills
);
export const selectBankReceiptReturnTransactions = createSelector(
  state => state.transaction.bankReceiptReturnTransaction.bankReceiptReturnTransactions,
  bills => bills
);
export const selectAccountIdWiseConsigneeBankReceiptReturnTransactions = createSelector(
  state => state.transaction.bankReceiptReturnTransaction.accountIdWiseConsigneeBankReceiptReturnTransactions,
  bills => bills
);
export const selectBankNameBankReceiptReturnTransactions = createSelector(
  state => state.transaction.bankReceiptReturnTransaction.bankNamesBankReceiptReturnTransactions,
  bills => bills
);
export const selectBankReceiptReturnsTotal = state => state.transaction.bankReceiptReturn.total;
export const selectBankReceiptReturnsWithPage = createSelector(
  state => state.transaction.bankReceiptReturn.bankReceiptReturnsPage,
  bills => bills
);

// Debit Note Bill Base
export const selectDebitNotesBillBaseLoading = state => state.transaction.debitNoteBillBase.loading;
export const selectDebitNotesBillBase = createSelector(
  state => state.transaction.debitNoteBillBase.debitNoteBillBases,
  bills => bills
);

export const selectDebitNoteBillBaseTotal = state => state.transaction.debitNoteBillBase.total;
export const selectDebitNotesBillBaseWithPage = createSelector(
  state => state.transaction.debitNoteBillBase.debitNoteBillBasesPage,
  bills => bills
);

// Debit Note Bill Base Return
export const selectDebitNotesBillBaseReturnsLoading = state => state.transaction.debitNoteBillBaseReturn.loading;
export const selectDebitNotesBillBaseReturns = createSelector(
  state => state.transaction.debitNoteBillBaseReturn.debitNoteBillBaseReturns,
  bills => bills
);

export const selectDebitNoteBillBaseReturnsTotal = state => state.transaction.debitNoteBillBaseReturn.total;
export const selectDebitNotesBillBaseReturnsWithPage = createSelector(
  state => state.transaction.debitNoteBillBaseReturn.debitNoteBillBaseReturnsPage,
  bills => bills
);

// Credit Note Bill Base Return
export const selectCreditNotesBillBaseReturnsLoading = state => state.transaction.creditNoteBillBaseReturn.loading;
export const selectCreditNotesBillBaseReturns = createSelector(
  state => state.transaction.creditNoteBillBaseReturn.creditNoteBillBaseReturns,
  bills => bills
);

export const selectCreditNoteBillBaseReturnsTotal = state => state.transaction.creditNoteBillBaseReturn.total;
export const selectCreditNotesBillBaseReturnsWithPage = createSelector(
  state => state.transaction.creditNoteBillBaseReturn.creditNoteBillBaseReturnsPage,
  bills => bills
);

///sale return 
export const selectSalesReturnLoading = state => state.inventory.salesReturn.loading;
export const selectSalesReturns = createSelector(
  state => state.inventory.salesReturn.salesReturns || [],
  bills => bills
);

export const selectSalesReturnBillOrders = createSelector(
  state => state.inventory.salesReturn.billOrders || [],
  bills => bills
);
export const selectSalesReturnTotal = state => state.inventory.salesReturn.total;
export const selectSalesReturnsWithPage = createSelector(
  state => state.inventory.salesReturn.salesReturnsPage,
  bills => bills
);

// general purchase bill
export const selectGeneralPurchaseBillLoading = state => state.inventory.generalPurchaseBill.loading;
export const selectGeneralPurchaseBill = createSelector(
  state => state.inventory.generalPurchaseBill.generalPurchaseBills,
  bills => bills
);

export const selectGeneralPurchaseBillTotal = state => state.inventory.generalPurchaseBill.total;
export const selectGeneralPurchaseBillWithPage = createSelector(
  state => state.inventory.generalPurchaseBill.generalPurchaseBillsPage,
  bills => bills
);

// general purchase return bill
export const selectGeneralPurchaseReturnBillLoading = state => state.inventory.generalPurchaseReturnBill.loading;
export const selectGeneralPurchaseReturnBill = createSelector(
  state => state.inventory.generalPurchaseReturnBill.generalPurchaseReturnBills,
  bills => bills
);

export const selectGeneralPurchaseReturnBillTotal = state => state.inventory.generalPurchaseReturnBill.total;
export const selectGeneralPurchaseReturnBillWithPage = createSelector(
  state => state.inventory.generalPurchaseReturnBill.generalPurchaseReturnBillsPage,
  bills => bills
);

// journal voucher
export const selectJournalVoucherLoading = state => state.transaction.journalVoucher.loading;
export const selectJournalVoucher = createSelector(
  state => state.transaction.journalVoucher.journalVouchers,
  bills => bills
);

export const selectJournalVoucherTotal = state => state.transaction.journalVoucher.total;
export const selectJournalVoucherWithPage = createSelector(
  state => state.transaction.journalVoucher.journalVouchersPage,
  bills => bills
);

// journal voucher(multy)
export const selectJournalVoucherMultyLoading = state => state.transaction.journalVoucherMulty.loading;
export const selectJournalVoucherMulty = createSelector(
  state => state.transaction.journalVoucherMulty.journalVoucherMultys,
  bills => bills
);

export const selectJournalVoucherMultyTotal = state => state.transaction.journalVoucherMulty.total;
export const selectJournalVoucherMultyWithPage = createSelector(
  state => state.transaction.journalVoucherMulty.journalVoucherMultysPage,
  bills => bills
);


// bank payment
export const selectBankPaymentsLoading = state => state.transaction.bankPayment.loading;
export const selectBankPayments = createSelector(
  state => state.transaction.bankPayment.bankPayments,
  bills => bills
);
export const selectAccountIdWiseConsigneeBankPaymentTransactions = createSelector(
  state => state.transaction.bankPaymentTransaction.accountIdWiseConsigneeBankPaymentTransactions,
  bills => bills
);
export const selectBankPaymentsTotal = state => state.transaction.bankPayment.total;
export const selectBankPaymentsWithPage = createSelector(
  state => state.transaction.bankPayment.bankPaymentsPage,
  bills => bills
);

export const selectDateWiseProductionLoading = state => state.inventory.dateWiseProduction.loading;
export const selectDateWiseProductions = createSelector(
  state => state.inventory.dateWiseProduction.dateWiseProductions,
  bills => bills
);
export const selectDateWiseProductionsTotal = state => state.inventory.dateWiseProduction.total;
export const selectDateWiseProductionWithPage = createSelector(
  state => state.inventory.dateWiseProduction.dateWiseProductionsPage,
  bills => bills
);

// date wise production difference
export const selectDateWiseProductionDifferenceLoading = state => state.inventory.dateWiseProductionDifference.loading;
export const selectDateWiseProductionDifferences = createSelector(
  state => state.inventory.dateWiseProductionDifference.dateWiseProductionDifferences,
  bills => bills
);
export const selectDateWiseProductionDifferencesTotal = state => state.inventory.dateWiseProductionDifference.total;
export const selectDateWiseProductionDifferencesWithPage = createSelector(
  state => state.inventory.dateWiseProductionDifference.dateWiseProductionDifferencesPage,
  bills => bills
);


// cash receipt
export const selectCashReceiptsLoading = state => state.transaction.cashReceipt.loading;
export const selectCashReceipts = createSelector(
  state => state.transaction.cashReceipt.cashReceipts,
  bills => bills
);
export const selectCashReceiptsTotal = state => state.transaction.cashReceipt.total;
export const selectCashReceiptsWithPage = createSelector(
  state => state.transaction.cashReceipt.cashReceiptsPage,
  bills => bills
);

// cash payment
export const selectCashPaymentsLoading = state => state.transaction.cashPayment.loading;
export const selectCashPayments = createSelector(
  state => state.transaction.cashPayment.cashPayments,
  bills => bills
);
export const selectCashPaymentsTotal = state => state.transaction.cashPayment.total;
export const selectCashPaymentsWithPage = createSelector(
  state => state.transaction.cashPayment.cashPaymentsPage,
  bills => bills
);

// Bank Slip Entry
export const selectBankSlipEntriesLoading = state => state.transaction.bankSlipEntry.loading;
export const selectBankSlipEntries = createSelector(
  state => state.transaction.bankSlipEntry.bankSlipEntries,
  bills => bills
);

export const selectAvailableRecieptTransactions = createSelector(
  state => state.transaction.bankSlipEntry.availableRecieptTransactions,
  bills => bills
);
export const selectBankSlipEntriesTotal = state => state.transaction.bankSlipEntry.total;
export const selectBankSlipEntriesWithPage = createSelector(
  state => state.transaction.bankSlipEntry.bankSlipEntriesPage,
  bills => bills
);

// Bank Payment Slip Entry
export const selectBankPaymentSlipEntriesLoading = state => state.transaction.bankPaymentSlipEntry.loading;
export const selectBankPaymentSlipEntries = createSelector(
  state => state.transaction.bankPaymentSlipEntry.bankPaymentSlipEntries,
  bills => bills
);

export const selectAvailablePaymentTransactions = createSelector(
  state => state.transaction.bankPaymentSlipEntry.availablePaymentTransactions,
  bills => bills
);
export const selectBankPaymentSlipEntriesTotal = state => state.transaction.bankPaymentSlipEntry.total;
export const selectBankPaymentSlipEntriesWithPage = createSelector(
  state => state.transaction.bankPaymentSlipEntry.bankPaymentSlipEntriesPage,
  bills => bills
);

// item lot rate
export const selectItemLotRateLoading = state => state.itemLotRate.loading;
export const selectItemLotRate = createSelector(
  state => state.itemLotRate.itemLotRate,
  bills => bills
);

export const selectItemLotRateTotal = state => state.itemLotRate.total;
export const selectItemLotRateWithPage = createSelector(
  state => state.itemLotRate.itemLotRatePage,
  bills => bills
);

export const selectYearEndProcessLoading = state => state.utility.yearEndProcess.loading;
export const selectYearEndProcessError = state => state.utility.yearEndProcess.error;
export const selectProfitLoss = createSelector(
  state => state.utility.yearEndProcess.profitLoss || {},
  option => option
);
export const selectYearEndProcessJvs = createSelector(
  state => state.utility.yearEndProcess.jvs || [],
  data => data
);

// Draft Debit Note Bill Base
export const selectDraftDebitNotesBillBaseLoading = state => state.draft.draftDebitNoteBillBase.loading;
export const selectDraftDebitNotesBillBase = createSelector(
  state => state.draft.draftDebitNoteBillBase.draftDebitNoteBillBases,
  bills => bills
);

export const selectDraftDebitNoteBillBaseTotal = state => state.draft.draftDebitNoteBillBase.total;
export const selectDraftDebitNotesBillBaseWithPage = createSelector(
  state => state.draft.draftDebitNoteBillBase.draftDebitNoteBillBasesPage,
  bills => bills
);

// Draft Credit Note Bill Base
export const selectDraftCreditNotesBillBaseLoading = state => state.draft.draftCreditNoteBillBase.loading;
export const selectDraftCreditNotesBillBase = createSelector(
  state => state.draft.draftCreditNoteBillBase.draftCreditNoteBillBases,
  bills => bills
);

export const selectDraftCreditNoteBillBaseTotal = state => state.draft.draftCreditNoteBillBase.total;
export const selectDraftCreditNotesBillBaseWithPage = createSelector(
  state => state.draft.draftCreditNoteBillBase.draftCreditNoteBillBasesPage,
  bills => bills
);


export const selectJobYarnIssueLoading = state => state.inventory.jobYarnIssue.loading;
export const selectJobYarnIssues = createSelector(
  state => state.inventory.jobYarnIssue.jobYarnIssues,
  bills => bills
);
export const selectJobYarnIssueTotal = state => state.inventory.jobYarnIssue.total;
export const selectJobYarnIssuesWithPage = createSelector(
  state => state.inventory.jobYarnIssue.jobYarnIssuesPage,
  bills => bills
);
export const selectJobYarnIssuesAvailableTransaction = createSelector(
  state => state.inventory.jobYarnIssue.availableTransactions,
  bills => bills
);

export const selectJobYarnReceiveLoading = state => state.inventory.jobYarnReceive.loading;
export const selectJobYarnReceives = createSelector(
  state => state.inventory.jobYarnReceive.jobYarnReceives,
  bills => bills
);
export const selectJobYarnReceiveTotal = state => state.inventory.jobYarnReceive.total;
export const selectJobYarnReceivesWithPage = createSelector(
  state => state.inventory.jobYarnReceive.jobYarnReceivesPage,
  bills => bills
);

export const selectJobYarnReturnLoading = state => state.inventory.jobYarnReturn.loading;
export const selectJobYarnReturns = createSelector(
  state => state.inventory.jobYarnReturn.jobYarnReturns,
  bills => bills
);
export const selectJobYarnReturnTotal = state => state.inventory.jobYarnReturn.total;
export const selectJobYarnReturnsWithPage = createSelector(
  state => state.inventory.jobYarnReturn.jobYarnReturnsPage,
  bills => bills
);

export const selectRightLoading = state => state.right.loading;
export const selectUserRight = createSelector(
  state => state.right.userRights || [],
  bills => bills
);

export const selectLockDataLoading = state => state.utility.lockData.loading;
export const selectLockDataError = state => state.utility.lockData.error;
export const selectLockData = createSelector(
  state => state.utility.lockData.lockData || {},
  option => option
);

export const selectPinnedModules = createSelector(
  state => state.module.pinnedModules || [],
  option => option
);